import { render, staticRenderFns } from "./PlacingDetailsAction.vue?vue&type=template&id=48787b84&scoped=true"
import script from "./PlacingDetailsAction.vue?vue&type=script&lang=js"
export * from "./PlacingDetailsAction.vue?vue&type=script&lang=js"
import style0 from "./PlacingDetailsAction.vue?vue&type=style&index=0&id=48787b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48787b84",
  null
  
)

export default component.exports